import api from "../../../api/axios";

const getServers = async () => {
  try {
    const response = await api.get("/api/servers", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    return { success: true, servers: response.data?.servers };
  } catch (error) {
    console.error("getServers response", error);
    return { success: false, loggedOut: error.response.status === 403 };
  }
};

const updateMachineGuid = async (serverUuid, machineGuid) => {
  try {
    const response = await api.put(`/api/servers/${serverUuid}/machineguid`, {
      machineGuid,
    });

    return response.status === 200 ? true : false;
  } catch (error) {
    console.error("updateMachineGuid response", error);
    return false;
  }
};

const deleteServer = async (serverUuid) => {
  try {
    const response = await api.delete(`/api/servers/${serverUuid}`);

    return response.status === 200 ? true : false;
  } catch (error) {
    console.error("deleteServer response", error);
    return false;
  }
};

const createServer = async (friendlyName) => {
  try {
    const { data } = await api.post(`/api/servers`, {
      friendlyName,
    });

    return { success: true, message: data };
  } catch (error) {
    console.error(
      error.response?.status,
      `createServer ERROR: ${error.message}`
    );
    return { success: false, message: error?.message };
  }
};

export default { getServers, deleteServer, createServer, updateMachineGuid };
